import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function DebitNoteList() {
  const { user } = useUser()
  let view = contentLayout[modules.DebitNoteList]
  if (user.permissions.views.length && !user.permissions.views.join().includes(modules.DebitNoteList.toLowerCase())) {
    view = Forbidden
  }
  return (
    <Index content={view} module={modules.DebitNoteList}></Index>
  )
}

export default DebitNoteList
